import { render, staticRenderFns } from "./CustomerContactForm.vue?vue&type=template&id=1a1efbfa&scoped=true"
import script from "./CustomerContactForm.vue?vue&type=script&lang=js"
export * from "./CustomerContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1efbfa",
  null
  
)

export default component.exports